// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"02027916","453":"638276a1"}[chunkId] + ".chunk.js";
};